import { noop } from 'lodash';

import {
   EducationalMaterial,
   EducationalMaterialOperationRegisterCommand,
} from '@dreryk/egabinet-knowledge-base-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';

export const useEducationalMaterialDashboardOperationRegisterCommand = (
   options: EducationalMaterial
): UseCqrsCommandResult => {
   return useCqrsCommand(
      () => {
         const command = new EducationalMaterialOperationRegisterCommand();
         command.educationalMaterialIds = [options.id];
         command.operationType = 'VIEW';
         command.operationOrigin = 'DASHBOARD';
         return command;
      },
      {
         onUnexpectedError: noop,
         background: true,
      }
   );
};
